var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophyBlueStrong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.22 1.17h21.54v12.15a10.77 10.77 0 1 1-21.54 0V1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52B0FF",
    d: "M20 16.79a3.33 3.33 0 0 1-3.33-3.33v-1.07h6.67v1.07A3.33 3.33 0 0 1 20 16.79Zm9.82 22.05H10.31l3-4.2h13.51l3 4.2Zm-14.36-8.13h8.98v3.93h-8.98v-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#15246D",
    fillRule: "evenodd",
    d: "M15.67 12.39a1 1 0 0 1 1-1h6.67a1 1 0 0 1 1 1v1.07A4.33 4.33 0 0 1 20 17.79a4.328 4.328 0 0 1-4.329-4.33v-1.07Zm2 1v.07A2.329 2.329 0 0 0 20 15.79h.003a2.33 2.33 0 0 0 2.337-2.33v-.07h-4.67Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#15246D",
    d: "M16.06 6.73a1.64 1.64 0 1 0 1.64 1.64 1.628 1.628 0 0 0-1.64-1.64Zm7.469.276c.27-.18.587-.276.911-.276a1.63 1.63 0 0 1 1.64 1.64 1.64 1.64 0 1 1-2.551-1.364Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#15246D",
    fillRule: "evenodd",
    d: "M7.44 2.17h.78v3.792a4.899 4.899 0 0 0-.7-1.013 4.12 4.12 0 0 0-3.047-1.42A4.08 4.08 0 0 0 1.41 4.95 4.85 4.85 0 0 0 .16 8.213a1 1 0 0 0 .003.08c.175 2.11 1.51 3.642 3.135 4.98.82.675 1.762 1.339 2.742 2.022l.263.183c.85.593 1.734 1.208 2.633 1.885A11.77 11.77 0 0 0 19 25.048v4.662h-3.54a1 1 0 0 0-1 1v2.93h-1.15a1 1 0 0 0-.814.419l-3 4.2a1 1 0 0 0 .814 1.581h19.51a1 1 0 0 0 .814-1.581l-3-4.2a1 1 0 0 0-.814-.419h-1.38v-2.93a1 1 0 0 0-1-1H21v-4.663a11.77 11.77 0 0 0 10.024-7.631c.921-.697 1.826-1.327 2.695-1.933l.27-.188c.979-.683 1.92-1.347 2.74-2.022 1.624-1.339 2.957-2.869 3.137-4.978a.844.844 0 0 0 .004-.087 4.9 4.9 0 0 0-1.24-3.249 4 4 0 0 0-6.17 0 4.904 4.904 0 0 0-.7 1.022V2.17h.93a1 1 0 1 0 0-2H7.44a1 1 0 1 0 0 2Zm2.78 11.15V2.17h19.54v11.15a9.77 9.77 0 1 1-19.54 0Zm21.54 0V9.098a1 1 0 0 0 1.46-.886 2.9 2.9 0 0 1 .775-1.97 2 2 0 0 1 3.1 0c.01.012.02.025.032.037a2.9 2.9 0 0 1 .743 1.89c-.124 1.261-.92 2.33-2.413 3.56-.749.617-1.626 1.237-2.613 1.926l-.27.189h-.002l-.004.003-.001.001-.861.602c.036-.374.054-.751.054-1.13Zm-23.54 0c0 .366.017.73.05 1.093a242.1 242.1 0 0 0-.82-.574l-.266-.185c-.987-.688-1.866-1.309-2.615-1.925-1.495-1.231-2.29-2.3-2.409-3.561a2.85 2.85 0 0 1 .76-1.909 2.08 2.08 0 0 1 1.552-.729 2.12 2.12 0 0 1 1.541.733l.013.016a2.9 2.9 0 0 1 .744 1.933 1 1 0 0 0 1.45.891v4.217Zm4.033 24.52 1.572-2.2h12.48l1.572 2.2H12.253Zm4.207-4.2v-1.93h6.98v1.93h-6.98Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyBlueStrong);
export default __webpack_public_path__ + "static/media/trophy-blue-strong.b821bc2cfffc003c02aa4627c50e655f.svg";
export { ForwardRef as ReactComponent };